import type { CourseLearnData } from '@lms/shared'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useCourseLearnData(courseId: string) {
  return useQuery({
    queryKey: ['learn', courseId],
    queryFn: () => api.get<CourseLearnData>(`/api/learn/${courseId}`),
    enabled: !!courseId,
  })
}
